import type { paths } from "@/api-schema";
import { alphartisApiAxios } from "@/config/axios";
import { useQuery } from "@tanstack/react-query";
import { optionsWithDefaults } from "../_helpers/options-with-defaults";
import { Options } from "../_types";

export const GROUP_BY_UUID_RESOURCE = "group" as const;
export const GROUP_BY_UUID_API_PATH = `/v1/${GROUP_BY_UUID_RESOURCE}/{uuid}` as const;

export type GroupByUuidParameters = paths[typeof GROUP_BY_UUID_API_PATH]["get"]["parameters"]["query"];
export type GroupByUuidResponse =
  paths[typeof GROUP_BY_UUID_API_PATH]["get"]["responses"][200]["content"]["application/json"];

export function useGroupByUuidQuery(uuid: string, options?: Options<GroupByUuidParameters, never>) {
  const optionsWithDefaultsResolved = optionsWithDefaults<Options<GroupByUuidParameters, never>>(options);

  const requestParameters = {
    ...(optionsWithDefaultsResolved.parameters || {}),
    extend: optionsWithDefaultsResolved.parameters?.extend || [],
  };

  return useQuery({
    enabled: !!uuid,
    queryKey: [GROUP_BY_UUID_RESOURCE, uuid, { parameters: requestParameters }],
    queryFn: async () => {
      const response = await alphartisApiAxios.get<GroupByUuidResponse>(`/v1/${GROUP_BY_UUID_RESOURCE}/${uuid}`, {
        params: requestParameters,
      });

      return response.data;
    },
  });
}
